export enum ViolationFixMethodsEnum {
  MOBILE_APP_INFO = 'INSPECTOR_MATERIAL',
  PUBLIC_INFO = 'PUBLIC_MATERIAL',
  EVENT_NO_CONTACT = 'EVENT_MATERIAL',
  CONTROLLED_PERSON_INFO = 'CONTROL_MATERIAL',
}
